import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    SegmentChatEvent,
    segmentTrackAction
} from '../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from 'app/middlewares/segment/trackEntities/cardEvents';
import * as React from 'react';

export const trackCommentSent = (
    event: React.KeyboardEvent<HTMLElement>,
    isChat: boolean
): ThunkAction => {
    return (dispatch: Dispatch) => {
        if (isChat) {
            dispatch(segmentTrackAction(SegmentChatEvent.COMMENT_ADDED));
        }
        if (event.ctrlKey || event.metaKey) {
            dispatch(segmentTrackAction(SegmentCardEvent.SENT_COMMENT , {
                name: SegmentCardOptions.SOURCE,
                value: SegmentCardSourceValue.HOTKEYS
            }, [{
                name: SegmentCardOptions.SOURCE,
                value: isChat ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
            }]));
        } else {
            dispatch(segmentTrackAction(SegmentCardEvent.SENT_COMMENT, {
                name: SegmentCardOptions.SOURCE,
                value: SegmentCardSourceValue.BUTTON
            }, [{
                name: SegmentCardOptions.SOURCE,
                value: isChat ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
            }]));
        }
    };
};
